/**
 * Simple Audio Analysis Prompt for Add Track Context
 * Minimal prompt relying on fine-tuned model's training
 */

export const createAddTrackAnalysisPromptSimple = (): string => {
  return `FIRST: Check track duration and use correct terminology:
- Under 7 seconds: Use "mnemonic" instead of "track"
- 7 to 15 seconds: MUST use "sting" instead of "track"
- Over 15 seconds: Use "track"

Analyze this audio and provide a description following this pattern:
"[mood] [time period] [genre] [mnemonic/sting/track] with [instruments], [additional characteristics] atmosphere"

Focus on:
- One primary genre
- Prominent mood and characteristics
- Only hero instruments (main/prominent instruments, not background elements)
- Descriptive atmosphere that aids in search and categorization

Provide a concise, natural description suitable for music library search.`;
};